import $ from "jquery";
import jBox from "jbox";
import { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import { QRCode } from "react-qrcode-logo";
import { koalaImg } from "utility/koalaImg";

const ModalQrCode = ({
  isOpen = false,
  onClose,
  memberId = null,
  pProfileImgUrl = null,
  lineImageUrl = null,
  Name = null,
}) => {
  const [modalFilter, setModalFilter] = useState(null);
  const [showTips, setShowTips] = useState(false);

  useEffect(() => {
    const initModal = new jBox("Modal", {
      closeButton: false,
      closeOnClick: false,
      minWidth: 325,
      maxWidth: 375,
      content: $("#ModalQR"),
    });
    setModalFilter(initModal);
    return () => initModal.destroy();
  }, []);

  useEffect(() => {
    if (!modalFilter) return;
    if (isOpen) {
      modalFilter.open();
    }

    const btnClose = document.getElementById("btnCloseModal");
    const onCloseClick = () => {
      modalFilter.close();
      onClose();
    };
    if (btnClose) {
      btnClose.addEventListener("click", onCloseClick);
    }
    return () => {
      if (btnClose) {
        btnClose.removeEventListener("click", onCloseClick);
      }
    };
  }, [modalFilter, isOpen, onClose]);

  const handleDownload = () => {
    setTimeout(() => {
      html2canvas(document.getElementById("ModalQR"), {
        scale: 3,
        useCORS: true,
      }).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "Koala-Member-QR.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    }, 500);
  };

  const profileImage = lineImageUrl || pProfileImgUrl;

  return (
    <div className="bModal bCard" id="ModalQR" style={{ display: "none" }}>
      <div className="bInner">
        <div className="bQR">
          <div className="bPic">
            {memberId ? (
              <QRCode
                value={memberId}
                size={256}
                logoImage={koalaImg}
                logoWidth={60}
                logoHeight={72}
                logoOpacity={1}
                enableCORS={true}
                qrStyle="squares"
                eyeRadius={0}
                id="QR"
              />
            ) : (
              <img src="https://dummyimage.com/200x200" alt="" />
            )}
          </div>

          <div>
            ชวนเพื่อนสมัครง่ายๆ เพียงสแกน QR Code
            <i className="btnTips" id="tips" onClick={() => setShowTips(true)}>
              {showTips && (
                <div className="bTips" style={{ display: "block" }}>
                  <a
                    className="btnCloseTips"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowTips(false);
                    }}
                  ></a>
                  <span>ชวนเพื่อนมาเป็นสมาชิกรับ Point เพิ่ม</span>
                  <p>
                    ชวนเพื่อนมาสมัครด้วยการเปิด QR code ให้เพื่อนสแกน หรือ
                    ก็อปปี้เลขไอดี ของตัวเอง ส่งให้เพื่อนกรอก
                  </p>
                  <p>
                    เลือกวิธีไหนก็ได้ คุณได้รับ point เพิ่มทันที
                    ยิ่งชวนเพื่อนเยอะ ยิ่งได้ Point เยอะ ชวนเพื่อนเลย!
                  </p>
                </div>
              )}
            </i>
          </div>
        </div>
        <div className="bMemberDetails">
          <div className="bDisplay">
            <div
              className="bPic"
              style={{ backgroundImage: profileImage ? `url(${profileImage})` : undefined }}
            ></div>
          </div>
          <div className="bDetails">
            <h2>{Name}</h2>
            <p className="bMemberID">
              ID : <a className="btnCopy">{memberId}</a>
            </p>
          </div>
        </div>
        <div className="bBtn">
          <p>
            แคปหน้าจอนี้เพื่อส่งต่อ
            <br />
            การ์ดโคอะลา มาร์ช ให้กับเพื่อน
            <br />
            เพื่อรับพอยต์สะสม x1 พอยต์
          </p>
        </div>
        <a className="btnCloseModal" id="btnCloseModal"></a>
      </div>
    </div>
  );
};

export default ModalQrCode;
